import { Helmet } from 'react-helmet-async';

import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// @mui
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import PropTypes from 'prop-types';
import {
  DeleteAttachment,
  DownloadTreeAttachment,
  GetAttachmentsList,
  GetClient,
  GetTask,
  MarkAsDoneReq,
  MarkAsWronglyAssignedReq,
  PostAttachment,
  PostPerformActivity,
} from 'src/components/services/httpServices';

import { Trash } from 'react-feather';

import { Download } from 'react-feather/dist';
import ActivitesHistory from 'src/components/Opportunities/ActivitesHistory';
import TasksListAgainstClient from 'src/components/Opportunities/TasksListAgainstClient';
import ModalLayout from 'src/theme/Modal';
import PdfViewerModal from '../Attachments/PdfViewerModal';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function ClientDetailsPage() {
  let { id, checkClient, taskId } = useParams();
  const navigate = useNavigate();
  const [client, setClient] = useState({});
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('sdsdsdsds');
  const [attachments, setAttachments] = useState({});
  const [ACTIVITIESLIST, setActivitiesList] = useState([]);
  //  for Attachment
  const [selectedFile, setSelectedFile] = useState([]);
  const [savedFiles, setSavedFiles] = useState([]);
  const [task, setTask] = useState(null);
  const [scannedDate, setScannedDate] = useState(null);

  const attachmentRef = useRef(null);
  const remarksRef = useRef('');

  const activityTypeRef = useRef('');
  const activitiyDateRef = useRef('');
  const activityTimeRef = useRef('');
  const followUpDateRef = useRef('');
  const commentsRef = useRef('');
  const nextStageRef = useRef('');
  const detailsRef = useRef('');

  const fetchAttachments = async (event) => {
    let attachments = await GetAttachmentsList(id, checkClient);
    setAttachments(attachments);
  };
  const fetchClient = async (event) => {
    const client = await GetClient(id);
    const attachments = await GetAttachmentsList(id, checkClient);
    const task = await GetTask(taskId);
    setTask(task.data);
    setAttachments(attachments);
    setClient(client);
    setLoading(false);
  };
  useEffect(() => {
    fetchClient();
  }, [selectedFile]);

  const handleClose = () => {
    setOpen(false);
  };
  const PerformActivity = async (event) => {
    event.preventDefault();

    //  console.log('editHit');
    setLoading(true);
    var payload = {};
    if (checkClient == 'true') {
      payload = {
        activityType: activityTypeRef.current.value,
        activityDate: activitiyDateRef.current.value,
        activityTime: activityTimeRef.current.value,
        followUpDate: followUpDateRef.current.value,
        comments: commentsRef.current.value,
        nextStage: nextStageRef.current.value,
        clientId: checkClient == 'true' ? id : null,
        companyIdList: [],
        clientIdList: [],
        details: detailsRef.current.value,
        subActivities: [],
      };
    } else {
      payload = {
        activityType: activityTypeRef.current.value,
        activityDate: activitiyDateRef.current.value,
        activityTime: activityTimeRef.current.value,
        followUpDate: followUpDateRef.current.value,
        comments: commentsRef.current.value,
        nextStage: nextStageRef.current.value,
        companyId: checkClient == 'false' ? id : null,
        companyIdList: [],
        clientIdList: [],
        subActivities: [],
      };
    }

    //console.log(payload);
    let response = await PostPerformActivity(payload);
    // console.log('PostResponse:', response);
    if (response.status == 200) {
      setMessage(response.data);
      setSaved(true);
      setOpen(true);
      setLoading(false);
      setTimeout(() => {
        navigate(`/app/MyTasks`);
      }, 2000);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };
  const SaveAttachment = async (event) => {
    event.preventDefault();
    setLoading(true);
    var payload = selectedFile;
    // console.log(payload);
    let response = await PostAttachment(id, payload, checkClient);
    // console.log('PostResponse:', response);
    if (response.status == 200) {
      fetchAttachments();
      setSelectedFile([]);
      setMessage(response.data);
      setSaved(true);
      setOpen(true);
      setLoading(false);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };
  const MarkAsDone = async (event) => {
    console.log('ACTIVITIESLIST', ACTIVITIESLIST);
    // if (ACTIVITIESLIST.length <= 0) {
    //   alert('Perform an activity first!');
    // } else {
    event.preventDefault();
    setLoading(true);
    let response = await MarkAsDoneReq(taskId);
    //console.log('PostResponse:', response);
    if (response.status == 200) {
      setMessage(response.data);
      setSaved(true);
      setOpen(true);
      setLoading(false);
      setTimeout(() => {
        navigate(`/app/MyTasks`);
      }, 2000);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpen(true);
      setLoading(false);
      setTimeout(() => {
        navigate(`/app/MyTasks`);
      }, 2000);
      // setPosting(false);
    }
    // }
  };
  const uploadFile = (event) => {
    event.preventDefault();
    const uploaded = [...selectedFile];
    for (let i = 0; i < event.target.files.length; i++) {
      let reader = new FileReader();
      let file = event.target.files[i];
      // console.log('FileName', file); //I can see the file's info

      reader.onload = (event) => {
        //   console.log('event', event.target.result[i]);
        // console.log("asas", reader.result);
        const row = {
          attachment: reader.result,
          fileName: file.name,
          docType: '',
          scannedDate: currentDateStr,
          docExpiryDate: '',
        };
        uploaded.push(row);
        // setSelectedFile([row]);
        console.log('row', row);
        // console.log("State", selectedFile);
      };
      reader.readAsDataURL(file);

      //  console.log('asas', reader.result);
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    }
    setSelectedFile(uploaded);
  };
  const deleteAttachmentRow = (fileName) => {
    //  console.log(selectedFile);
    const newList = selectedFile.filter((item) => item.fileName !== fileName);
    //  console.log('new List', newList);

    // setGrandTotal(parseInt(grandTotal) - price * quantity);
    setSelectedFile(newList);
  };

  const GetAttachment = async (path) => {
    // var file = await DownloadAttachment(path);
    var file = await DownloadTreeAttachment('1', false, '', path, false);
    //   console.log('file', file);
    const url = window.URL.createObjectURL(new Blob([file.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', path); //or any other extension
    document.body.appendChild(link);
    link.click();
  };
  const deleteAttachment = async (attachment) => {
    event.preventDefault();
    setLoading(true);

    //   console.log('IDD:', attachment);
    let response = await DeleteAttachment(attachment);
    //   console.log('Console:', response);
    if (response.status == 200) {
      const newList = attachments.filter((item) => item.id !== attachment);
      setAttachments(newList);
      setMessage(response.data);
      setSaved(true);
      setOpen(true);
      setLoading(false);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpen(true);
      setLoading(false);
    }
  };

  const MarkAsWronglyAssigned = async (event) => {
    event.preventDefault();
    setLoading(true);
    let response = await MarkAsWronglyAssignedReq(taskId);
    //  console.log('PostResponse:', response);
    if (response.status == 200) {
      setMessage(response.data);
      setSaved(true);
      setOpen(true);
      setLoading(false);
      setTimeout(() => {
        navigate(`/app/MyTasks`);
      }, 2000);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpen(true);
      setLoading(false);
      setTimeout(() => {
        navigate(`/app/MyTasks`);
      }, 2000);
      // setPosting(false);
    }
  };
  //console.log('company', client);
  const ChangeDateHandle = (event, index) => {
    setScannedDate(event.target.value);

    selectedFile[index].scannedDate = event.target.value;
  };
  const ChangeDocTypeHandle = (event, index, type) => {
    selectedFile[index].docType = type?.value;
  };
  const ChangeExpiryDateHandle = (event, index) => {
    selectedFile[index].docExpiryDate = event.target.value;
  };
  const docTypes = [
    { value: 'Permit' },
    { value: 'Communication' },
    { value: 'Submission' },
    { value: 'Questionnaire' },
    { value: 'Fee Receipt' },
    { value: 'Invoice' },
    { value: 'Passport' },
    { value: 'Work permit' },
    { value: 'LMIA' },
    { value: 'Education' },
    { value: 'Employment reference' },
    { value: 'Alberta job offer' },
    { value: 'Pay stubs' },
    { value: 'Proof of funds' },
    { value: 'Dependent form' },
    { value: 'Use of rep' },
    { value: 'Questionnaire' },
    { value: 'T4 summary' },
    { value: 'Attestation letter' },
    { value: 'Additional Documents' },
  ];

  const currentDate = new Date();
  const currentHour = currentDate.getHours().toString().padStart(2, '0');
  const currentMinute = currentDate.getMinutes().toString().padStart(2, '0');
  const currentTime = `${currentHour}:${currentMinute}:00`;

  const currentYear = currentDate.getFullYear().toString();
  const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // add 1 to get the correct month
  const currentDay = currentDate.getDate().toString().padStart(2, '0');
  const currentDateStr = `${currentYear}-${currentMonth}-${currentDay}`;
  return (
    <>
      <Helmet>
        <title> Client | Immigration System </title>
      </Helmet>
      <Container>
        {/* <Box
          p={4}
          component={Paper}
          boxShadow={3}
          sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
        > */}
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Client Details
          </Typography>

          <Stack direction="row" spacing={2}>
            <Button
              onClick={() => {
                navigate(-1);
              }}
              variant="contained"
            >
              Back
            </Button>
            {/* <Button onClick={SaveAttachment} variant="contained">
              Save
            </Button> */}
          </Stack>
        </Stack>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <>
            <Box
              p={4}
              marginBottom={4}
              component={Paper}
              boxShadow={3}
              sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
            >
              <Grid container spacing={3}>
                <Grid item xs={6} sm={3} md={12}>
                  <Typography variant="h6" color="initial">
                    <span style={{ color: '#ad1f22' }}>{task?.activityName}:</span>
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    <span style={{ color: '#ad1f22' }}>{task?.comments}</span>
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Full Name :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.fullName}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Contact:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.phoneNumber}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Alternate Contact:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.altCntctNum}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Email:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.email}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Resident Address:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.residentAddress}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Date of Birth:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.dateOfBirth?.split('T')[0]}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Place of Birth:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.placeOfBirth}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Citizenship:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.citizenship}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Current Country:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.currentCountry}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Martial Status:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.martialStatus}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Client Type:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.clientType}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Application Type:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.applicationType}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Status:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.status}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            {task?.status !== 'Done' ? (
              <form onSubmit={PerformActivity}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                  <Typography variant="h4" gutterBottom>
                    Perform Activity
                  </Typography>

                  <Stack direction="row" spacing={2}>
                    <Button variant="outlined">
                      <ModalLayout
                        title="Mark as Wrongly Assigned"
                        description="Are You sure you want to Mark as Wrongly Assigned?"
                        Hit={MarkAsWronglyAssigned}
                      />
                    </Button>
                    <Button variant="outlined">
                      <ModalLayout
                        title="Mark as Done"
                        description="Are You sure you want to Mark as Done?"
                        Hit={MarkAsDone}
                      />
                    </Button>
                    <Button type="submit" variant="contained">
                      Save
                    </Button>
                  </Stack>
                </Stack>

                <Box
                  p={3}
                  component={Paper}
                  boxShadow={3}
                  marginBottom={4}
                  sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Activity Type"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={activityTypeRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Activity Date"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        type="date"
                        // defaultValue={user.userName}
                        InputLabelProps={{ shrink: true }}
                        inputRef={activitiyDateRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Activity Time"
                        required
                        type="time"
                        variant="outlined"
                        fullWidth
                        size="small"
                        // defaultValue={user.password}
                        InputLabelProps={{ shrink: true }}
                        inputRef={activityTimeRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Follow Up Date"
                        variant="outlined"
                        fullWidth
                        size="small"
                        type="date"
                        // defaultValue={user.userEmail}
                        inputRef={followUpDateRef}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Comments"
                        variant="outlined"
                        fullWidth
                        size="small"
                        // defaultValue={user.userEmail}
                        inputRef={commentsRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Next Stage"
                        variant="outlined"
                        fullWidth
                        size="small"
                        // defaultValue={user.userEmail}
                        inputRef={nextStageRef}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </form>
            ) : null}
            {task?.status !== 'Done' ? (
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                <Typography variant="h4" gutterBottom>
                  Add Documents
                </Typography>

                <Stack direction="row" spacing={2}>
                  <TextField
                    type="file"
                    label=""
                    size="small"
                    inputProps={{ multiple: true }}
                    inputRef={attachmentRef}
                    onChange={uploadFile}
                  />
                  <Button onClick={SaveAttachment} variant="contained">
                    Attach
                  </Button>
                </Stack>
              </Stack>
            ) : null}
            {task?.status !== 'Done' ? (
              <Box
                p={3}
                component={Paper}
                boxShadow={3}
                marginBottom={4}
                sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <br></br>
                    <br></br>
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Sr#</TableCell>

                            <TableCell>Attachment Name</TableCell>
                            <TableCell>Scanned Date</TableCell>
                            <TableCell>Document Type</TableCell>
                            <TableCell>Document Expiry Date</TableCell>
                            <TableCell>Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {selectedFile?.map((row, index) => (
                            <TableRow key={index + 1}>
                              <TableCell>{index + 1}</TableCell>

                              <TableCell>{row.fileName}</TableCell>

                              <TableCell>
                                <TextField
                                  label="Scaned Date"
                                  variant="outlined"
                                  fullWidth
                                  defaultValue={currentDateStr}
                                  size="small"
                                  type="date"
                                  onChange={(event) => ChangeDateHandle(event, index)}
                                  InputLabelProps={{ shrink: true }}
                                />{' '}
                              </TableCell>

                              <TableCell>
                                <Autocomplete
                                  id="docType"
                                  size="small"
                                  options={docTypes}
                                  // defaultValue={userList.find((e) => e.key == user.deptId)}
                                  getOptionLabel={(source) => source.value}
                                  renderInput={(params) => (
                                    <TextField {...params} label="Doc Type" variant="outlined" />
                                  )}
                                  onChange={(event, type) => ChangeDocTypeHandle(event, index, type)}
                                />
                              </TableCell>
                              <TableCell>
                                <TextField
                                  label="Doc Expiry Date"
                                  variant="outlined"
                                  fullWidth
                                  size="small"
                                  type="date"
                                  onChange={(event) => ChangeExpiryDateHandle(event, index)}
                                  InputLabelProps={{ shrink: true }}
                                />{' '}
                              </TableCell>
                              <TableCell>
                                <IconButton
                                  onClick={() => deleteAttachmentRow(row.fileName)}
                                  aria-label="delete"
                                  size="small"
                                >
                                  <Trash />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </Box>
            ) : null}
            {task?.status !== 'Done' ? (
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                <Typography variant="h4" gutterBottom>
                  Saved Documents
                </Typography>
              </Stack>
            ) : null}
            {task?.status !== 'Done' ? (
              <Box
                p={3}
                component={Paper}
                boxShadow={3}
                sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <br></br>
                    <br></br>
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Sr#</TableCell>
                            <TableCell>Document Name</TableCell>

                            <TableCell>Scanned Date</TableCell>
                            <TableCell>Document Type</TableCell>
                            <TableCell>Document Expiry</TableCell>
                            <TableCell>Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {attachments?.map((row, index) => (
                            <TableRow key={index + 1}>
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{row.docName}</TableCell>

                              <TableCell>{row.scannedDate?.split('T')[0]}</TableCell>
                              <TableCell>{row.docType}</TableCell>
                              <TableCell>{row.docExpiryDate?.split('T')[0]}</TableCell>
                              <TableCell>
                                <IconButton size="small">
                                  <PdfViewerModal file={row.name} filePath={row.path} treeView={false} title="View" />
                                </IconButton>
                                <IconButton onClick={() => GetAttachment(row.path)} aria-label="delete" size="small">
                                  <Download />
                                </IconButton>
                                <IconButton aria-label="delete" size="small">
                                  <ModalLayout
                                    // title="Delete"
                                    component={<Trash />}
                                    description="Are You Sure you want to Delete?"
                                    Hit={() => deleteAttachment(row.id)}
                                  />
                                  {/* <Trash borderColor='red' /> */}
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </Box>
            ) : null}
          </>
        )}
        {/* </Box> */}
      </Container>
      {task?.status !== 'Done' ? <ActivitesHistory setActivitiesList={setActivitiesList} /> : null}
      {task?.status !== 'Done' ? <TasksListAgainstClient /> : null}
      {saved ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
            {message}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          key={vertical + horizontal}
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
            {message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
